import { observer } from 'mobx-react';
import CheckmarkIcon from '../../../../../../../Cutesies/CheckmarkIcon';
import Modal from '../../../../../../../Modal';
import Body from './Body';
import InviteParticipantStore from '../../Store';
import { ParticipantsInvited } from '../../Types';
import ModalButton from './ModalButton';

interface Props {
  store: InviteParticipantStore;
  state: ParticipantsInvited;
}

export const resetModal = (store: InviteParticipantStore) => {
  store.modalStore.close();
  store.waiting();
};

function ParticipantsInvitedModal({ store, state }: Props) {
  return (
    <Modal
      title={<CheckmarkIcon className="mx-auto mt-16" />}
      close={() => resetModal(store)}
      customBackgroundCssClasses="bg-teal-100 opacity-60"
      additionalClasses="text-center"
      modalWidth="w-2/5"
    >
      <Body
        successfulCommunicationsCount={state.successfulCommunicationsCount}
        sendEmailDate={state.sendEmailDate}
        skipCommunications={state.skipCommunications}
      >
        <ModalButton store={store} shareUrl={state.shareUrl} />
      </Body>
    </Modal>
  );
}

export default observer(ParticipantsInvitedModal);
